import { Message, useMessage } from '@messageformat/react';
import { Row, Col, Tile } from '@op/opds.opux';
import { IconStock } from '@op/opds.opux-icons/finance';
import { IconResearch } from '@op/opds.opux-icons/misc';
import { space } from '@op/opds.tokens';
import { ReactElement } from 'react';
import CourseContent from '../CourseContent';
import TextComponent from '../TextComponent';
import { ReactComponent as Image008 } from '../../images/OP_symbolikuvitus_96_008.svg';
import { ReactComponent as Image027 } from '../../images/OP_symbolikuvitus_96_027.svg';
import { ReactComponent as Image095 } from '../../images/OP_symbolikuvitus_96_095.svg';
import { ReactComponent as Image121 } from '../../images/OP_symbolikuvitus_96_121.svg';
import { ReactComponent as Image059 } from '../../images/OP_symbolikuvitus_128_059.svg';
import { ReactComponent as Image006 } from '../../images/OP_symbolikuvitus_96_006.svg';
import { ReactComponent as Image139 } from '../../images/OP_symbolikuvitus_96_139.svg';
import { ReactComponent as ImagePaint } from '../../images/paint.svg';
import { ReactComponent as ImageSun } from '../../images/sun.svg';
import parseMsgContent from '../../util/parseMsgContent';

const PartTwo = (): ReactElement => {
  const partTwoConsidering = useMessage('course8.part2.considering.content');
  const parsedPartTwoConsidering = parseMsgContent(partTwoConsidering);
  return (
    <div
      className="opds-styles-v1-text-body-medium"
      style={{
        paddingBottom: space.default,
        paddingTop: space.default,
      }}
    >
      <TextComponent messageId="course8.part2.intro" twoColumns={false} />
      <Image008 aria-hidden="true" className="investoracademy-small-svg" />
      <h3 className="opds-styles-v1-text-title-xxl investoracademy-centered-and-padding-default-text">
        <Message id="course8.part2.first_title" />
      </h3>
      <TextComponent messageId="course8.part2.values" twoColumns />
      <h4 className="opds-styles-v1-text-title-large investoracademy-centered-and-padding-default-text">
        <Message id="course8.part2.example1.title" />
      </h4>
      <Image095 aria-hidden="true" className="investoracademy-small-svg" />
      <h5
        style={{ color: '#EE5A00', textAlign: 'center' }}
        className="opds-styles-v1-text-title-xxl"
      >
        <Message id="course8.part2.example1.person1" />
      </h5>
      <TextComponent messageId="course8.part2.example1.body" twoColumns={false} />
      <Image027 aria-hidden="true" className="investoracademy-small-svg" />
      <h3 className="opds-styles-v1-text-title-xxl investoracademy-centered-and-padding-default-text">
        <Message id="course8.part2.riskmanagement_title" />
      </h3>
      <TextComponent messageId="course8.part2.riskmanagement" twoColumns />
      <h4 className="opds-styles-v1-text-title-large investoracademy-centered-and-padding-default-text">
        <Message id="course8.part2.question1.title" />
      </h4>
      <div style={{ textAlign: 'center', paddingBottom: space.default }}>
        <Message id="course8.part2.question1.subtitle" />
      </div>
      <Row style={{ margin: 0, paddingLeft: 0, paddingBottom: space.xxxl }}>
        <Col md={6} xs={12} className="investoracademy-multi-column-left-small-padding">
          <Tile>
            <ImagePaint className="investoracademy-small-svg" aria-hidden="true" />
            <h5
              style={{
                textAlign: 'center',
                paddingBottom: space.xs,
              }}
              className="opds-styles-v1-text-title-small-strong"
            >
              <Message id="course8.part2.question1.company1_title" />
            </h5>
            <TextComponent
              messageId="course8.part2.question1.company1"
              twoColumns={false}
            />
          </Tile>
        </Col>
        <Col md={6} xs={12} className="investoracademy-multi-column-right-small-padding">
          <Tile>
            <Image121 className="investoracademy-small-svg" aria-hidden="true" />
            <h5
              style={{
                textAlign: 'center',
                paddingBottom: space.xs,
              }}
              className="opds-styles-v1-text-title-small-strong"
            >
              <Message id="course8.part2.question1.company2_title" />
            </h5>
            <TextComponent
              messageId="course8.part2.question1.company2"
              twoColumns={false}
            />
          </Tile>
        </Col>
      </Row>
      <ImageSun className="investoracademy-small-svg" aria-hidden="true" />
      <h3 className="opds-styles-v1-text-title-xxl investoracademy-centered-and-padding-default-text">
        <Message id="course8.part2.sustainable_investments.title" />
      </h3>
      <TextComponent messageId="course8.part2.sustainable_investments.body" twoColumns />
      <h4 className="opds-styles-v1-text-title-large investoracademy-centered-and-padding-default-text">
        <Message id="course8.part2.example2.title" />
      </h4>
      <Image059 className="investoracademy-small-svg" aria-hidden="true" />
      <h5
        style={{ color: '#EE5A00', textAlign: 'center' }}
        className="opds-styles-v1-text-title-xxl"
      >
        <Message id="course8.part2.example2.person1" />
      </h5>
      <TextComponent messageId="course8.part2.example2.body" twoColumns={false} />
      <Row style={{ margin: 0, paddingLeft: 0, paddingBottom: space.xxxl }}>
        <Col md={6} xs={12} className="investoracademy-multi-column-left-small-padding">
          <Tile>
            <Image006 className="investoracademy-small-svg" aria-hidden="true" />
            <h6
              style={{
                textAlign: 'center',
                paddingBottom: space.xs,
              }}
              className="opds-styles-v1-text-title-small-strong"
            >
              <Message id="course8.part2.example2.company1.title" />
            </h6>
            <Message id="course8.part2.example2.company1.body1" />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: space.xs,
                marginBottom: space.xs,
              }}
            >
              <IconResearch size="large" />
            </div>
            <Message id="course8.part2.example2.company1.body2" />
          </Tile>
        </Col>
        <Col md={6} xs={12} className="investoracademy-multi-column-right-small-padding">
          <Tile>
            <Image121 className="investoracademy-small-svg" aria-hidden="true" />
            <h6
              style={{
                textAlign: 'center',
                paddingBottom: space.xs,
              }}
              className="opds-styles-v1-text-title-small-strong"
            >
              <Message id="course8.part2.example2.company2.title" />
            </h6>
            <Message id="course8.part2.example2.company2.body1" />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: space.xs,
                marginBottom: space.xs,
              }}
            >
              <IconStock size="large" />
            </div>
            <Message id="course8.part2.example2.company2.body2" />
          </Tile>
        </Col>
      </Row>
      <Image139
        className="investoracademy-small-svg"
        style={{ paddingBottom: space.default, fill: 'currentcolor' }}
        aria-hidden="true"
      />
      <h4
        style={{
          textAlign: 'center',
          paddingBottom: space.default,
        }}
        className="opds-styles-v1-text-title-small-strong"
        id="considering"
      >
        <Message id="course8.part2.considering.title" />
      </h4>
      <CourseContent content={parsedPartTwoConsidering} />
    </div>
  );
};

export default PartTwo;
